import 'url-search-params-polyfill'
import 'whatwg-fetch'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import 'navigator.sendbeacon/dist/navigator.sendbeacon.min.js'
import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import { key, store } from '@/store'
import i18n from '@gd/i18n'
import CHorizontalProgress from '@/components/CHorizontalProgress.vue'
import Modal, { loadModalComponents } from '@gd/modal'
import CLoadingIndicator from '@/components/CLoadingIndicator.vue'
import { TechHint } from '@gd/game-technologies-check'
import { loadTComponents } from '@gd/t-components'
import '@gd/t-components/dist/t-components.css'
import '@gd/classic-template/dist/classic-template.css'
// import required styles
import '@/styles/index.less'
import '@/styles/generic.less'
import '@/styles/table.less'
import '@gd/common-styles/dist/fonts/dSari-loadFonts.less'
import '@gd/modal/dist/modal.css'
import '@/styles/tooltip.less'
import '@gd/game-technologies-check/dist/game-technologies-check.css'

const app = createApp(App).use(router).use(store, key).use(i18n)
loadTComponents(app)
loadModalComponents(app)
app.component('c-horizontal-progress', CHorizontalProgress)
app.component('gd-modal', Modal)
// TODO vue3 replace with t-progress
app.component('c-loading-indicator', CLoadingIndicator)
app.component('c-tech-hint', TechHint)

app.mount('#app')
